import { TrackingScreenNamesEnum } from '../tracking/tracking.data';

export const APPOINTMENTS_VIEW_ROUTE = 'view';
export const APPOINTMENTS_EDIT_ROUTE = 'edit';
export const APPOINTMENTS_NEW_ROUTE = 'new';
export const APPOINTMENTS_SEARCH_ROUTE = 'search';

export interface IAppointmentRouteData {
  trackingScreenName: TrackingScreenNamesEnum;
}
